
define('text!presentation/common/clockDisplay/views/clockDisplay.html',[],function () { return '<span data-bind="text: clockDisplay" />\n';});

